import { datapolisRecords } from './datapolisData'

const claimStatuses = [
    'Laporan diterima',
    'Menunggu Dokumen',
    'Menunggu Konfirmasi',
    'Identifikasi Asuransi',
    'Propose Asuransi',
    'Menunggu Pembayaran',
    'Klaim dibayar',
    'Klaim ditolak',
    'Review Ulang',
    'Klaim Diluar Periode',
]

const claimTypes = ['Natural Death', 'Personal Accident', 'PHK/PAW', 'Gagal Bayar']
const packages = ['A1', 'A2', 'C1', 'C2', 'C3', 'C4', 'C6']

function generateClaimDate(periodeAwal, offsetDays) {
    const d = new Date(periodeAwal)
    d.setDate(d.getDate() + offsetDays)
    return d.toISOString().split('T')[0]
}

function generateClaims() {
    const claims = []

    // Generate 20 claims from existing datapolis records
    const claimIndices = [0, 2, 5, 7, 9, 11, 14, 16, 18, 20, 22, 24, 27, 29, 31, 33, 36, 38, 41, 44]

    for (let i = 0; i < 20; i++) {
        const polisIndex = claimIndices[i]
        const polis = datapolisRecords[polisIndex]
        const status = claimStatuses[i % claimStatuses.length]
        const claimType = claimTypes[i % claimTypes.length]
        const claimAmount = Math.round(polis.main_credit * (0.3 + (i % 5) * 0.15))
        const approvedAmount = ['Klaim dibayar'].includes(status) ? claimAmount : (['Klaim ditolak', 'Klaim Diluar Periode'].includes(status) ? 0 : null)
        const filingDate = generateClaimDate(polis.periode_awal, 60 + (i * 15))
        const claimDate = generateClaimDate(polis.periode_awal, 45 + (i * 15))
        const agingClaim = Math.floor((new Date() - new Date(filingDate)) / (1000 * 60 * 60 * 24))

        claims.push({
            id: i + 1,
            uuid: `clm-${String(i + 1).padStart(4, '0')}`,
            bank_id: parseInt(polis.pusat_id),
            bank_name: polis.nama_pusat,
            bank_pusat_name: polis.nama_pusat,
            bank_cabang_name: polis.nama_cabang,
            insurance_id: parseInt(polis.insurance_id),
            insurance_name: polis.company_name,
            name: polis.name,
            id_card_type: 'KTP',
            id_card_number: polis.id_card_number,
            credit_agreement_number: polis.policy_number,
            birth_of_date: polis.date_of_birth,
            liquid_credit_date: polis.periode_awal,
            credit_end_date: polis.periode_akhir,
            premium_rate: polis.premium_rate,
            main_credit: polis.main_credit,
            date_of_filing: filingDate,
            claim_date: claimDate,
            claim_amount: claimAmount,
            approved_claim_amount: approvedAmount,
            claim_type: claimType,
            claim_status: status,
            claim_configuration_id: 1,
            document_complete: i % 3 !== 0,
            propose_date: ['Propose Asuransi', 'Menunggu Pembayaran', 'Klaim dibayar'].includes(status) ? generateClaimDate(filingDate, 14) : null,
            propose_signed_date: ['Menunggu Pembayaran', 'Klaim dibayar'].includes(status) ? generateClaimDate(filingDate, 21) : null,
            paid_refusal_date: status === 'Klaim dibayar' ? generateClaimDate(filingDate, 30) : (status === 'Klaim ditolak' ? generateClaimDate(filingDate, 25) : null),
            reason_for_refusal: status === 'Klaim ditolak' ? 'Dokumen tidak lengkap atau tidak memenuhi persyaratan' : null,
            letter_institution: null,
            name_of_letter_institution: null,
            sending_status: i % 5 === 0 ? 'sent' : 'not_sent',
            aging_claim: agingClaim,
            staging_id: `stg-${String(polisIndex + 1).padStart(4, '0')}`,
            new_business_id: polis.uuid,
            restitusi_id: null,
            deleted_at: null,
            is_pre_finance: i % 4 === 0,
            document_requirements: [
                { name: 'Surat Keterangan Meninggal', status: i % 3 !== 0 ? 1 : 0 },
                { name: 'Fotokopi KTP Tertanggung', status: 1 },
                { name: 'Fotokopi Perjanjian Kredit', status: i % 2 === 0 ? 1 : 0 },
                { name: 'Surat Keterangan Ahli Waris', status: i % 4 !== 0 ? 1 : 0 },
            ],
            ClaimAnalysis: {
                kronis: i % 7 === 0,
                ganda: false,
                terlambat_lapor: i % 5 === 0,
                kronologi_invalid: i % 9 === 0,
                inv_klaim: i % 3 === 0,
                inv_klaim_insurance: i % 4 === 0,
                inv_bulanan: false,
                inv_terlambat_bayar: i % 6 === 0,
                is_waiting_period: i % 8 === 0,
                is_stnc: false,
                rapid_claim: claimAmount < 5000000,
                note: null,
            },
            ClaimConfiguration: {
                project_id: 'proj-001',
                mou_number: '157/PKS-BSSB/V/2019',
                product_id: '1',
                product_name: 'Asuransi Jiwa Kredit',
                paket_code: packages[i % packages.length],
                paket_type: 'Standard',
            },
        })
    }
    return claims
}

export const claimRecords = generateClaims()

export const claimNotes = [
    { id: '1', claim_id: 1, created_by: 'sysadmin', message: 'Dokumen awal sudah diterima, menunggu kelengkapan.', created_at: '2024-03-20 10:00:00' },
    { id: '2', claim_id: 1, created_by: 'insurance', message: 'Perlu verifikasi tambahan untuk surat kematian.', created_at: '2024-03-22 14:30:00' },
    { id: '3', claim_id: 3, created_by: 'sysadmin', message: 'Klaim sedang dalam proses review.', created_at: '2024-05-15 09:00:00' },
    { id: '4', claim_id: 5, created_by: 'insurance', message: 'Dokumen lengkap, siap diproses.', created_at: '2024-07-10 11:00:00' },
]

export const claimCountAnalysis = {
    total: 20,
    laporan_diterima: 2,
    menunggu_dokumen: 2,
    menunggu_konfirmasi: 2,
    identifikasi_asuransi: 2,
    propose_asuransi: 2,
    menunggu_pembayaran: 2,
    klaim_dibayar: 2,
    klaim_ditolak: 2,
    review_ulang: 2,
    klaim_diluar_periode: 2,
}
